module.exports = __webpack_public_path__ + "static/media/reposteria_checked.4df22a22.svg";